$(document).ready(function() {
  function reindexBeneficialOwners() {
    const beneficialOwners = $("#beneficial_owner_list").find(".beneficial-owner");
    beneficialOwners.each(function(index) {
      $(this).find(".js-beneficial-owner-number").text(index + 1);
      $(this).find(":input").each(function() {
        const name = $(this).attr("name");
        const newName = name.replace(/(\[\d+\])?(\[\w+\])$/, `[${index}]$2`);
        $(this).attr("name", newName);
      });
    });
  };

  function updateAddAndRemoveLinks() {
    removeItemLinks = $(".remove_beneficial_owner_link")

    if (list.children().length > 1) {
      removeItemLinks.removeClass("d-none");
    } else {
      removeItemLinks.addClass("d-none");
    }

    if (list.children().length < 15) {
      addItemLink.removeClass("d-none");
    } else {
      addItemLink.addClass("d-none");
    }
  }

  function addBeneficialOwnerHandler(e) {
    e.preventDefault();

    if (list.children().length < 15) {
      const newItem = baseFormNode.clone();
      newItem.find('input[type="text"], textarea').val('');
      newItem.find('input[type="date"]').val('');
      newItem.find('input[type="hidden"]').val('');
      newItem.appendTo(list);
      newItem.find(".remove_beneficial_owner_link").on("click", removeBeneficialOwnerHandler);
      reindexBeneficialOwners();
      updateAddAndRemoveLinks();
      $(document).trigger("preparePageForAddressAutoComplete");
    }
  }

  function removeBeneficialOwnerHandler(e) {
    e.preventDefault();

    if (list.children().length > 1) {
      $(this).closest(".accordion-item").remove();
      $(this).closest(".beneficial-owner").remove();
      reindexBeneficialOwners();
      updateAddAndRemoveLinks();
    }
  }

  $(document).on("click", ".beneficial-owner .js-beneficial-owner-header", function() {
    $(this).toggleClass("active-accordion");
    $(this).siblings(".js-beneficial-owner-body").slideToggle();
    if($(this).hasClass("active-accordion")) {
      $(this).find(".js-see-btn-label").text("Voir plus");
      $(this).find("img").removeClass("rotate-180");
    } else {
      $(this).find(".js-see-btn-label").text("Voir moins");
      $(this).find("img").addClass("rotate-180");
    }
  });

  const baseFormNode = $("#beneficial_owner_list").find(".beneficial-owner").first();

  const list = $("#beneficial_owner_list");
  const addItemLink = $("#add_beneficial_owner_link")
  let removeItemLinks = $(".remove_beneficial_owner_link")

  reindexBeneficialOwners();
  updateAddAndRemoveLinks();

  if(list.find(".beneficial-owner").length == 0) {
    $(window).on("load", addBeneficialOwnerHandler);
  }

  addItemLink.on("click", addBeneficialOwnerHandler);
  removeItemLinks.on("click", removeBeneficialOwnerHandler);
});
